import React, { useEffect, useState } from "react";
import Ths from "./Ths";
import "./thead.css";
import { useSelector, useDispatch } from "react-redux";
import { setActiveSearch } from "../../../../redux/slices/operationHomeSlice";
import { setActiveSort } from "../../../../redux/slices/operationHomeSlice";

const Theads = ({
  columnConfig,
  data,
  onSearch,
  handleSort,
  transactionTable,
  activeSearches = {}, // Receive active searches prop
}) => {
  const activeSearch = useSelector((state) => state.operationHome.activeSearch);
  const activeSort = useSelector((state) => state.operationHome.activeSort);
  const dispatch = useDispatch();

  const [sortConfig, setSortConfig] = useState({ key: null, direction: null });

  useEffect(() => {
    if (activeSort === "") {
      setSortConfig({ key: null, direction: null });
    }
  }, [activeSort]);

  const handleColumnSort = (key, direction) => {
    console.log("key", key);
    setSortConfig({ key, direction });
    handleSort(key, direction);
    dispatch(setActiveSort(key));
  };

  // Helper function to get search key for column
  const getSearchKeyForColumn = (columnId) => {
    const columnMapping = {
      memberId: "customerId",
      category: "callCategory",
      status: "callStatus",
      CRSScore: "crsTotalScoreOfFive",
    };
    return columnMapping[columnId] || columnId;
  };

  // Helper function to get display name for columns
  const getColumnDisplayName = (columnKey) => {
    const displayNames = {
      customerId: "Member ID",
      memberName: "Member Name",
      agentName: "Agent Name",
      urgency: "Urgency",
      CallType: "Call Type",
      qualityOfCall: "Quality",
      crsTotalScoreOfFive: "CRS Score",
      customerPhone: "Call From/To",
      MobileNumber: "Mobile Number",
      ReferralType: "Referral Type",
      HID: "HID",
      MemberName: "Member Name",
      // agentScore: "Agent Score",
      AgentName: "Agent Name",
      callCategory: "Category",
      callStatus: "Status",
      engagementDate: "Date",
      severity: "Severity",
    };

    return displayNames[columnKey] || columnKey;
  };

  return (
    <thead className="thead-scroll">
      <tr>
        {columnConfig.map((col) => {
          const searchKey = getSearchKeyForColumn(col.id);
          const isActiveSearch = activeSearches[searchKey];

          return (
            <Ths
              key={col.id}
              column={col}
              data={data}
              onSearch={onSearch}
              activeSearch={activeSearch}
              handleSort={handleColumnSort}
              transactionTable={transactionTable}
              sortConfig={sortConfig}
              setActiveSearch={(id) => dispatch(setActiveSearch(id))}
              activeSort={activeSort}
              setActiveSort={(id) => dispatch(setActiveSort(id))}
              // Pass additional props for active search highlighting
              isSearchActive={!!isActiveSearch}
              searchValue={isActiveSearch || ""}
              columnDisplayName={getColumnDisplayName(searchKey)}
            />
          );
        })}
      </tr>
    </thead>
  );
};

export default Theads;
